import React, { Component } from 'react'
import CircularProgress from "../../useful/CircularProgress";


class FileComponent extends Component {
    state = {
        fileName: "this is document one for"
    }
    render() {
        return (
            <div style={{ width: 250 }}>
                <div style={{ width: 250, height: 60, borderRadius: 20, borderBottomRightRadius: 0, background: "#E9ECF6", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ background: "#fff", width: "90%", height: 35, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img style={{ width: 20, height: 20, marginLeft: 7 }} src='/images/document.png' />
                            <p style={{ color: "#000", fontSize: 13, marginLeft: 8 }}>{this.state.fileName.length > 18 ? this.state.fileName.substring(0, 18) + "..." : this.state.fileName}</p>
                        </div>
                        {this.props.status == 1 ?
                            <>
                                <div style={{ marginRight: 7, cursor: "pointer", display: 'flex', alignItems: "center", justifyContent: "center" }}>
                                    <CircularProgress size={27} strokeWidth={2} progress={50} />
                                </div>
                            </>
                            : this.props.status == 0 ?
                                <>
                                    <img style={{ width: 20, height: 20, marginRight: 7, cursor: "pointer" }} src='/images/download.png' /> 
                                </>
                                : this.props.status == 2 ? <>
                                                                
                                </> : <></>
                        }

                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row-reverse", alignItems: "center", marginLeft: 10 }}>
                    <p style={{ color: "gray", fontSize: 12 }}>4:20PM</p>
                    <img style={{ width: 15, height: 15 }} src='/images/sent.png' />
                </div>
            </div>
        )
    }
}

export default FileComponent;